export const getIsInEditor = () => {
  return !!(typeof window !== "undefined" && window.storyblok?.isInEditor());
};
